import React from 'react';
import styles from './Score.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Score = ({ icon, score, total, label }) => {
  return (
    <div className={styles.points}>
      <span className={classNames(styles.icon, styles.noDesktop)}>
        {icon && icon()}
      </span>
      {score} / {total}
      <span className={styles.noMobile}> {label}</span>
    </div>
  );
};

Score.propTypes = {
  icon: PropTypes.func,
  score: PropTypes.number,
  total: PropTypes.number,
  label: PropTypes.string,
};

Score.defaultProps = {
  icon: null,
  score: 1,
  total: 1,
  label: null,
};

export default Score;
